import Icon from 'ms-ui-primitives/Icon';

import type { Props } from '../types';

const Tilde = ({
  color,
  size,
  title,
  titleId,
  aphroditeStyles = [],
}: Props) => (
  <Icon
    color={color}
    size={size}
    aphroditeStyles={aphroditeStyles}
    title={title}
    titleId={titleId}
    viewBoxWidth={8}
    viewBoxHeight={12}
  >
    <path d="M6.512 3.64L7.68 3.784C7.52 5.704 7.088 7.64 5.376 7.64C4.192 7.64 3.856 6.648 3.568 5.832C3.36 5.24 3.184 4.728 2.736 4.728C2.032 4.728 1.744 6.104 1.6 7.656L0.416 7.512C0.592 5.592 1.04 3.656 2.736 3.656C3.92 3.656 4.256 4.632 4.544 5.464C4.752 6.072 4.928 6.584 5.376 6.584C6.08 6.584 6.384 5.24 6.512 3.64ZM20.7468" />
  </Icon>
);
Tilde.displayName = 'Tilde';

export default Tilde;
